import styled from "styled-components";

export const CartContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 95vw;
  height: 100%;
  background: #0077b6;
  color: #a4161a;
  text-align: center;
  font-size: 1.3rem;
`;

export const ButtonContainer = styled("div")`
  display: flex;
  justify-content: center;
  gap: 5vw;
`;
